import { DncCheckMode } from "@/enum/DncCheckMode";
import { DncListStatus } from "@/enum/DncListStatus";

export interface CampaignCompliancePreflight {
  totalNumbers: number;
  writtenConsentNumbers?: number;
  unscrubbedNumbers: number;
  onDncListNumbers: number;
  litigatorNumbers: number;
  checksInProgress: number;
  checkPricePerNumber: number;
  registryNoticeUrl: string;
  callerIdsWithoutCallFlow?: string[];
}

export const CONTACT_WARNING = "CONTACT_WARNING";
export const DNC_CHECK_QUEUED = "DNC_CHECK_QUEUED";
export const DNC_BLOCKED = "DNC_BLOCKED";
export const LITIGATOR_BLOCKED = "LITIGATOR_BLOCKED";

export type ContactComplianceCode =
  | typeof CONTACT_WARNING
  | typeof DNC_CHECK_QUEUED
  | typeof DNC_BLOCKED
  | typeof LITIGATOR_BLOCKED;

export interface ContactComplianceRefusal {
  code: ContactComplianceCode;
  detail: string;
  phoneNumbers: string[];
  instantPrice?: number;
  delayedPrice?: number;
  warning?: "NO_CONSENT";
  learnMoreUrl?: string;
}

export interface OutboundGuardOptions {
  acknowledgeQuietHours: boolean;
  acknowledgeContactWarning: boolean;
  suppressContactWarning: boolean;
  dncCheck?: DncCheckMode;
}

export interface DncLookupPrices {
  available: boolean;
  instantPrice: number;
  delayedPrice: number;
}

export interface DncLookupResult {
  phoneNumberE164: string;
  listStatus: DncListStatus | null;
}

export interface DncLookupResponse {
  results: DncLookupResult[];
  queuedCount: number;
}

export interface QuietHoursCheckResult {
  withinCallingHours: boolean;
}

/** Why one recipient could not be contacted, as reported by the server. */
export interface QuietHoursBlockedRecipient {
  phoneNumber: string;
  /** OUTSIDE — known to be in quiet hours. UNKNOWN — their local time could not be determined. */
  reason: "OUTSIDE" | "UNKNOWN" | "CAPPED";
  calleeTimezone?: string | null;
  calleeLocalTime?: string | null;
  region?: string | null;
  regionName?: string | null;
  explanation?: string;
}

export interface QuietHoursBlockedError {
  code: typeof QUIET_HOURS_CONFIRM_REQUIRED | typeof QUIET_HOURS_BLOCKED;
  detail: string;
  /** False when the organisation's policy forbids contact outright — no confirmation will help. */
  overridable: boolean;
  blocked: QuietHoursBlockedRecipient[];
}

export const QUIET_HOURS_CONFIRM_REQUIRED = "QUIET_HOURS_CONFIRM_REQUIRED";
export const QUIET_HOURS_BLOCKED = "QUIET_HOURS_BLOCKED";

export interface SmsEligibility {
  allowed: boolean;
  orgApproved: boolean;
  reason?: string;
}

export interface A2pPricingRates {
  brandStandard: number;
  brandLowVolume: number;
  campaignVetting: number;
  recurringSoleProprietor: number;
  recurringLowVolume: number;
  recurringStandard: number;
  assistedRegistration: number;
  assistedSchedulingUrl?: string;
}
